import { createAction } from "redux-actions";
import {
  ChecklistShiftFilters,
  ChecklistTaskFilters,
  CompleteChecklistShiftPayload,
  ReturnChecklistShiftPayload,
  ShiftItem,
  TaskItem,
} from "./types";
import type { DateValueType } from "react-tailwindcss-datepicker";

const PREFIX = "CHECKLIST_TASKS";

export const fetchChecklistTasks = createAction<ChecklistTaskFilters>(`${PREFIX}/FETCH`);
export const fetchChecklistTasksSuccess = createAction<{ tasks: TaskItem[]; filters: ChecklistTaskFilters }>(
  `${PREFIX}/FETCH_SUCCESS`
);
export const fetchChecklistTasksFailure = createAction<string | null>(`${PREFIX}/FETCH_FAILURE`);

export const fetchChecklistShift = createAction<ChecklistShiftFilters>(`${PREFIX}/FETCH_SHIFT`);
export const fetchChecklistShiftSuccess = createAction<{ shifts: ShiftItem[]; filters: ChecklistShiftFilters }>(
  `${PREFIX}/FETCH_SHIFT_SUCCESS`
);
export const fetchChecklistShiftFailure = createAction<string | null>(`${PREFIX}/FETCH_SHIFT_FAILURE`);
export const completeChecklistShift = createAction<CompleteChecklistShiftPayload>(`${PREFIX}/COMPLETE_SHIFT`);
export const completeChecklistShiftSuccess = createAction<{ ID: number; payload: CompleteChecklistShiftPayload }>(
  `${PREFIX}/COMPLETE_SHIFT_SUCCESS`
);
export const completeChecklistShiftFailure = createAction<string | null>(`${PREFIX}/COMPLETE_SHIFT_FAILURE`);
export const returnChecklistShiftToWork = createAction<ReturnChecklistShiftPayload>(`${PREFIX}/RETURN_SHIFT_TO_WORK`);
export const returnChecklistShiftToWorkSuccess = createAction<ReturnChecklistShiftPayload>(
  `${PREFIX}/RETURN_SHIFT_TO_WORK_SUCCESS`
);
export const returnChecklistShiftToWorkFailure = createAction<string | null>(
  `${PREFIX}/RETURN_SHIFT_TO_WORK_FAILURE`
);

export const fetchChecklistTaskById = createAction<{
  connectionId: number;
  targetEmail: string;
  currentUserEmail: string;
  periodDate: DateValueType;
}>(`${PREFIX}/FETCH_BY_ID`);
export const fetchChecklistTaskByIdFailure = createAction<string | null>(`${PREFIX}/FETCH_BY_ID_FAILURE`);

export const upsertChecklistTask = createAction<TaskItem>(`${PREFIX}/UPSERT`);
export const setChecklistSelectedTaskId = createAction<number | null>(`${PREFIX}/SET_SELECTED`);
export const updateChecklistTaskLocally = createAction<{ connectionId: number; changes: Partial<TaskItem> }>(
  `${PREFIX}/UPDATE_LOCAL`
);
export const setChecklistPeriodDate = createAction<DateValueType>(`${PREFIX}/SET_PERIOD_DATE`);
export const resetChecklistPeriodDate = createAction(`${PREFIX}/RESET_PERIOD_DATE`);
export const resetChecklistTasks = createAction(`${PREFIX}/RESET`);
